import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useMemo } from 'react';
import { createTheme, ThemeProvider, useMediaQuery } from '@mui/material';
import { useBaseTheme } from './base-theme';
import { selectThemeType } from '../selector';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { StylesOverrides } from './style-overrides';
import { useDesignPackage } from 'console/shared/hooks/helpers';
import brand from 'shared/app/model/branding';
const default_user_theme = {};
export function UnconnectedThemeProvider(props) {
    const { themeType, children, brand_code, withStyleOverrides, additional_theme, user_theme, } = props;
    const preferDarkMode = useMediaQuery('(prefers-color-scheme: dark)', { noSsr: true });
    const theme_brand_code = brand_code ?? 'zont';
    const base_theme = useBaseTheme(themeType, theme_brand_code, user_theme);
    const theme = useMemo(() => createTheme(base_theme, additional_theme ?? {}), [additional_theme, preferDarkMode, base_theme]);
    return (_jsx(ThemeProvider, { theme: theme, children: (withStyleOverrides ?? true) ? (_jsx(StylesOverrides, { children: children })) : (children) }));
}
export function UIThemeProvider(props) {
    const { children, ...rest } = props;
    const themeType = useAppSelector(selectThemeType);
    const user_theme = useAppSelector((state) => state.account.theme);
    const allow_design_package = useDesignPackage();
    const _user_theme = useMemo(() => (allow_design_package ? user_theme : default_user_theme), [allow_design_package, user_theme]);
    return (_jsx(UnconnectedThemeProvider, { themeType: themeType, user_theme: _user_theme, brand_code: brand.code, ...rest, children: children }));
}
